/**
 * Thread loading functionality
 * Handles loading messages from backend and transforming them
 */

import type { ThreadMessage } from '@/types/messages';
import { getThreadMessages } from '@/api/threads.api';
import { transformApiMessagesToThreadMessages } from '../messages/MessageTransformer';
import { logger } from '@/utils/logger';

export class ThreadLoader {
  /**
   * Load messages for a thread from the backend
   */
  async loadThreadMessages(
    projectId: string,
    threadId: string,
  ): Promise<ThreadMessage[]> {
    try {
      const backendMessages = await getThreadMessages(projectId, threadId);
      return transformApiMessagesToThreadMessages(backendMessages, threadId);
    } catch (error) {
      logger.error('Error loading thread messages:', error);
      throw error;
    }
  }
}
